var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"headers":_vm.$options.diagnosticsHeadersConfig,"items":_vm.diagnostics,"loading":_vm.isLoading,"disable-pagination":true,"hide-default-footer":true}})}
var staticRenderFns = []

export { render, staticRenderFns }